@let debtorForm = form();
@let countryList = countries();
@let repTypes = representativeTypes();
@let partyTypeIdOptions = partyTypeOptions();
<form [formGroup]="debtorForm">
  @if (value.company_updated_at) {
    <span>
      <span>Utolsó frissítés:</span>
      <span>
        {{ value.company_updated_at | date: "yyyy.MM.dd. HH:mm" }}
      </span>
    </span>
  }

  <payee-form-field width="wide">
    <input
      payee-input
      [formControl]="name"
      [matAutocomplete]="debtorAuto"
      (input)="onCompanySearchInput($event)"
    />
    <span payee-label>Név</span>
    <mat-autocomplete
      #debtorAuto="matAutocomplete"
      [requireSelection]="false"
      (optionSelected)="companySelected($event)"
    >
      @for (option of autocompleteOptions; track option.tax_number || option.name) {
        <mat-option [value]="option">
          {{ option.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </payee-form-field>

  <payee-form-field width="wide">
    <input
      payee-input
      [formControl]="tax_number"
    />
    <span payee-label>Adószám</span>
  </payee-form-field>

  <payee-form-field width="wide">
    <payee-autocomplete
      [formControl]="party_type_id"
      [options]="partyTypeIdOptions"
      [displayWith]="partyTypeDisplayWith"
      [clearable]="true"
      [requireSelection]="false"
    ></payee-autocomplete>
    <span payee-label>Adós típusa</span>
  </payee-form-field>

  <app-bank-account-form [form]="bank_account"></app-bank-account-form>
  <app-address-form
    [countries]="countryList"
    [form]="address"
  ></app-address-form>

  @if (!isOrg(debtorForm)) {
    <h2>Személyes adatok</h2>
    <payee-form-field width="wide">
      <payee-datepicker [formControl]="birth_date"></payee-datepicker>
      <span payee-label>Születési idő</span>
    </payee-form-field>
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="birth_name"
      />
      <span payee-label>Születési név</span>
    </payee-form-field>
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="birth_place"
      />
      <span payee-label>Születési hely</span>
    </payee-form-field>
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="employer_name"
      />
      <span payee-label>Munkáltató neve</span>
    </payee-form-field>
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="mother_name"
      />
      <span payee-label>Anyja születési neve</span>
    </payee-form-field>
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="personal_id"
      />
      <span payee-label>Személyi azonosító</span>
    </payee-form-field>
  }
  @if (!isHouse(debtorForm)) {
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="registration_number"
      />
      <span payee-label>Nyilvántartási szám</span>
    </payee-form-field>
  }

  @if (isOrg(debtorForm)) {
    <div class="flex vcenter top-margin-15">
      <h1>Képviselők</h1>
      @if (!debtorForm.value.lock_representatives) {
        <button
          payee-icon-button
          color="white"
          [isBorderButton]="true"
          (click)="lockRepresentatives()"
        >
          <payee-icon name="pencil"></payee-icon>
        </button>
      }
      @if (debtorForm.value.lock_representatives) {
        <button
          payee-icon-button
          color="white"
          [isBorderButton]="true"
          (click)="unlockRepresentatives()"
        >
          <payee-icon name="lock-grey"></payee-icon>
        </button>
      }
    </div>
    <app-representatives-form
      [representatives]="representatives"
      [representativeTypes]="repTypes"
      [countries]="countryList"
    ></app-representatives-form>
  }
</form>
